import { Sparkles } from "lucide-react";
import { Button } from "./ui/button";

const navLinks = [
	{ label: "How it works", href: "#how-it-works" },
	{ label: "Features", href: "#features" },
	{ label: "Team", href: "#team" },
	{ label: "Contact", href: "mailto:contact@trysquash.dev" },
];

export function Header() {
	return (
		<header className="fixed top-0 left-0 right-0 z-50">
			<div className="container mx-auto px-4 sm:px-6 lg:px-8">
				<div className="mt-6 flex items-center justify-between rounded-full border border-white/80 bg-white/70 px-5 py-3 shadow-lg shadow-primary/10 backdrop-blur-xl md:px-8">
					<div className="flex items-center gap-3">
						<div className="flex items-center justify-center h-10 w-10 rounded-full bg-primary/10">
							<img src="/logo.svg" alt="Squash" className="h-6 w-6" />
						</div>
						<div className="flex flex-col leading-tight">
							<span className="text-lg font-semibold text-foreground">
								Squash
							</span>
							<span className="text-xs text-muted-foreground">
								Community Intelligence
							</span>
						</div>
					</div>
					<nav className="hidden items-center gap-1 text-sm font-medium text-muted-foreground md:flex">
						{navLinks.map((link) => (
							<a
								key={link.label}
								href={link.href}
								className="rounded-full px-4 py-2 transition-colors hover:bg-primary/10 hover:text-foreground"
							>
								{link.label}
							</a>
						))}
					</nav>
					<div className="flex items-center gap-3">
						<a
							className="rounded-full border border-primary/20 px-4 py-2 text-xs font-semibold text-primary shadow-sm shadow-primary/10 md:hidden"
							href="https://form.typeform.com/to/tnUCbmX4"
						>
							Early Access
						</a>
						<Button
							size="sm"
							className="hidden gap-2 rounded-full bg-primary px-5 py-2 text-sm font-semibold md:flex"
							asChild
						>
							<a href="https://form.typeform.com/to/tnUCbmX4">
								<Sparkles className="h-4 w-4" />
								Early Access
							</a>
						</Button>
					</div>
				</div>
			</div>
		</header>
	);
}
